import { CanDeactivateFn } from '@angular/router';
import { FULL_ACCESS_DENIED_ROUTE } from '@routes';
import { Observable } from 'rxjs';

export interface CanDeactivateDataImport {
  canDeactivate(): boolean | Observable<boolean>;
}

export const dataImportDeactivateGuard: CanDeactivateFn<CanDeactivateDataImport> = (
  component,
  _currentRoute,
  _currentState,
  nextState
) => {
  // Skip the discard confirmation when the user is being redirected due to a forbidden/unauthorized response.
  if (nextState?.url.startsWith(FULL_ACCESS_DENIED_ROUTE)) {
    return true;
  }

  return component?.canDeactivate ? component.canDeactivate() : true;
};
